<dialog-draggable-header>Add Reason Code</dialog-draggable-header>

<gm-loading-spinner *ngIf="loading"></gm-loading-spinner>


   <mat-dialog-content>
   <form class="container" [formGroup]="this.form">
      <div class="row">
         <mat-form-field class="col" floatLabel="always">
            <input matInput placeholder="Reason Code" style="text-transform: uppercase" maxlength="10"
               formControlName="reasonCode" />
         </mat-form-field>
         <mat-form-field class="col" floatLabel="always">
            <input matInput placeholder="Area" maxlength="20" formControlName="area" />
         </mat-form-field>
      </div>
      <div class="row mt-2">
         <mat-form-field class="col" floatLabel="always">
            <input matInput placeholder="Description" maxlength="60" formControlName="description" />
         </mat-form-field>
         <mat-form-field class="col" floatLabel="always">
            <input matInput placeholder="Definitions" maxlength="255" formControlName="definitions" />
         </mat-form-field>
      </div>

      <div class="row">
         <mat-checkbox class="col" color="primary" disableRipple formControlName="designLateFinish">Design Late Finish?
         </mat-checkbox>
         <mat-checkbox class="col" color="primary" disableRipple formControlName="constLateFinish">Const Late Finish?
         </mat-checkbox>
         <mat-checkbox class="col" color="primary" disableRipple formControlName="active">Active?</mat-checkbox>
      </div>
      
   </form>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions-end no-margin">
      <span class="cgp-flex-fill"></span>
      <button color="primary" mat-raised-button (click)="onSaveClick()" (keypress.enter)="onSaveClick()"
         [disabled]="loading || this.form.invalid">Save</button>
      <button mat-raised-button mat-dialog-close [disabled]="loading">Cancel</button>
</mat-dialog-actions>